import FormatDateFilter from './format-date';
import FormatDateTimeFilter from './format-datetime';
import FormatBankTxState from './format-banktx-state.js';
import FormatMoney from './format-money';
import FormatPaymentItemTypeFilter from './format-paymentitem-type';
import FormatClientName from './format-client';
import ToArrayFilter from './toarray';
import FormatGroupInvoiceStatusFilter from './format-group-invoice-status';
import angular from 'angular';

let filtersModule = angular.module('app.filters', [])
    .filter('formatDate', FormatDateFilter)
    .filter('formatDateTime', FormatDateTimeFilter)
    .filter('formatBankTxState', FormatBankTxState)
    .filter('formatMoney', FormatMoney)
    .filter('formatPaymentItemType', FormatPaymentItemTypeFilter)
    .filter('formatClientName', FormatClientName)
    .filter('formatGroupInvoiceStatus', FormatGroupInvoiceStatusFilter)
    .filter('toArray', ToArrayFilter)
    .name;

export default filtersModule;
